// PaymentSection.jsx
import React from "react";
import { FormControl, RadioGroup, FormControlLabel, Radio, Button, Typography, Box, Stack } from "@mui/material";
import { styled } from "@mui/material";
import CustomerPaymentPage from "../../../../../platform/pages/customer/customerPaymentPage";
 
const Next = styled((props) => <Button variant="contained" {...props} />)(
  ({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    boxShadow: "none",
    borderRadius: "16px",
    width: "100%",
    minHeight: "46px",
    marginTop: "16px",
    color: theme.palette.primary.contrastText,
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.95rem",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
      boxShadow: "none",
    },
    "&.Mui-disabled": {
      backgroundColor: theme.palette.action.disabledBackground,
      color: theme.palette.action.disabled,
      opacity: 1,
    },
  })
); 


const PaymentSection = ({ selectedOption, onOptionChange, bookingTypedata, hasError, onConfirm, answers, email, disableReason, businessUrl }) => {
  return (
    <Box
      sx={{
        p: { xs: 1.5, sm: 1.75 },
        borderRadius: 3,
        border: 1, borderColor: "divider",
        bgcolor: "background.paper",
        color: "text.primary",
      }}
    >
      <Stack spacing={1.25}>
        <Box>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "text.primary" }}>
            Confirm Booking
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, lineHeight: 1.7 }}>
            Review your booking option and continue when you are ready to reserve the appointment.
          </Typography>
        </Box>
      {Number(bookingTypedata?.price) > 0 && (
        <FormControl>
          <RadioGroup value={selectedOption} onChange={onOptionChange}>
            <FormControlLabel value="payNow" control={<Radio />} label="Pay Now" />
            <FormControlLabel value="payLater" control={<Radio />} label="Pay Later" disabled={bookingTypedata.isPaymentRequired} />
          </RadioGroup>
        </FormControl>
      )}
      {Number(bookingTypedata?.price) > 0 ? (
        selectedOption === "payNow" ? (
          // You can integrate your CustomerPaymentPage here.
          // It should call onConfirm when the payment is approved. 
          <CustomerPaymentPage businessUrl={businessUrl} disabled={hasError} onApprove={provider => onConfirm(undefined, undefined, provider)}/>
        ) : (
          <Next disabled={hasError} onClick={() => onConfirm()}>Schedule Booking</Next>
        )
      ) : (
        <Next disabled={hasError} onClick={() => onConfirm()}>Schedule Booking</Next>
      )}
      {hasError && disableReason && (
        <Typography variant="body2" color="error" sx={{ mt: 1, maxWidth: 340 }}>
          {disableReason}
        </Typography>
      )}
      </Stack>
    </Box>
  );
};

export default PaymentSection;
